class CartManager {
    constructor() {
        this.init();
        this.cartContent = '';
    }

    init() {
        document.addEventListener("line-item:change", this.handleCartDrawerChange.bind(this));
        document.addEventListener("cart-page:change", this.handleCartPageChange.bind(this));
    }

    handleCartPageChange(event) {
        const detail = event.detail;
        const lineKey = detail.line;
        const groupID = detail.groupID;
        const qty = detail.quantity;
        const groupProducts = document.querySelectorAll('.hasGroup');


        let updates = {};

        if (groupProducts.length > 0) {
            groupProducts.forEach(groupProduct => {
                let groupIDAttr = groupProduct.getAttribute('data-group-id');
                let lineIDAttr = groupProduct.getAttribute('data-line-key');
                if ( groupID == groupIDAttr ) {
                    updates[lineIDAttr] = qty;
                }
            });
        } 

        if (Object.keys(updates).length != 0) { // Using Object.keys to check for non-empty object
            this.updateCart(updates, true);
            updates = {};
        } else {
            window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${qty}`;
        }
    }

    handleCartDrawerChange(event) {

        if (event.detail.baseEvent == 'group-item:change') return; 

        const detail = event.detail;
        const groupID = detail['groupID'];
        const qty = detail['quantity'];
        const cartData = detail["cart"];
        const cartItems = cartData.items;
        let updates = {};


        if ( qty  == 0 ) {
            if (cartItems.length > 0) {
                
                if ( groupID != '' ) {
                    for (let i = 0; i < cartItems.length; i++) {
                        let item = cartItems[i];
                        if (groupID == item.properties._customizer_group_id) {
                            updates[item.key] = qty;
                        }
                    }
                }

                if (Object.keys(updates).length != 0) { // Using Object.keys to check for non-empty object
                    this.updateCart(updates, false);
                    updates = {};
                } else {
                    console.log('No Add-ons to update');
                }
            }
        }
    }

    updateCart(updates, page_refresh = false) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: updates
            })
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(errorText => {
                    throw new Error(errorText);
                });
            }
            return response.json();
        })
        .then(data => {
            if ( page_refresh ) {
                window.location.href = `${Shopify.routes.root}cart`;
            } else {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
    }
}

// Usage
const cartManager = new CartManager();
